import * as $ from '../../../../../../node_modules/jquery/dist/jquery.min.js';
(window as any).$ = $;
(window as any).jquery = $;
(window as any).jQuery = $;
